import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, CheckCircleIcon, AlertCircleIcon, TrashIcon, PencilIcon, LockIcon } from 'lucide-react';
const ManageBankAccounts = () => {
  const [bankAccounts, setBankAccounts] = useState([{
    id: 1,
    name: 'Primary Business Account',
    accountName: 'Acme Supplies Pty Ltd',
    bsb: '123-456',
    accountNumber: '****7890',
    isVerified: true,
    isDefault: true
  }, {
    id: 2,
    name: 'New Account detected',
    accountName: 'Acme Supplies Pty Ltd',
    bsb: '789-012',
    accountNumber: '****3456',
    isVerified: false,
    isDefault: false
  }]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newAccount, setNewAccount] = useState({
    name: '',
    accountName: '',
    bsb: '',
    accountNumber: ''
  });
  const handleAddAccount = () => {
    // In a real app, this would call an API to add the account
    const newId = Math.max(...bankAccounts.map(account => account.id)) + 1;
    setBankAccounts([...bankAccounts, {
      id: newId,
      name: newAccount.name,
      accountName: newAccount.accountName,
      bsb: '****',
      accountNumber: '****' + newAccount.accountNumber.slice(-4),
      isVerified: false,
      isDefault: false
    }]);
    setNewAccount({
      name: '',
      accountName: '',
      bsb: '',
      accountNumber: ''
    });
    setShowAddForm(false);
  };
  const handleSetDefault = (id: number) => {
    setBankAccounts(bankAccounts.map(account => ({
      ...account,
      isDefault: account.id === id
    })));
  };
  const handleDelete = (id: number) => {
    setBankAccounts(bankAccounts.filter(account => account.id !== id));
  };
  return <div className="space-y-6" data-id="element-156">
      <div className="flex justify-between items-center" data-id="element-157">
        <div data-id="element-158">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-159">Bank Accounts</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-160">
            Manage your bank accounts for receiving payments
          </p>
        </div>
        <button type="button" onClick={() => setShowAddForm(true)} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-161">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-162" />
          Add Account
        </button>
      </div>
      {showAddForm && <div className="bg-white shadow sm:rounded-lg" data-id="element-163">
          <div className="px-4 py-5 sm:p-6" data-id="element-164">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-165">
              Add New Bank Account
            </h3>
            <div className="mt-5 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-166">
              <div className="sm:col-span-3" data-id="element-167">
                <label htmlFor="account-name" className="block text-sm font-medium text-gray-700" data-id="element-168">
                  Account Label
                </label>
                <div className="mt-1" data-id="element-169">
                  <input type="text" name="account-name" id="account-name" value={newAccount.name} onChange={e => setNewAccount({
                ...newAccount,
                name: e.target.value
              })} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="e.g. Primary Business Account" data-id="element-170" />
                </div>
              </div>
              <div className="sm:col-span-3" data-id="element-171">
                <label htmlFor="holder-name" className="block text-sm font-medium text-gray-700" data-id="element-172">
                  Account Holder Name
                </label>
                <div className="mt-1" data-id="element-173">
                  <input type="text" name="holder-name" id="holder-name" value={newAccount.accountName} onChange={e => setNewAccount({
                ...newAccount,
                accountName: e.target.value
              })} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="e.g. Acme Supplies Pty Ltd" data-id="element-174" />
                </div>
              </div>
              <div className="sm:col-span-3" data-id="element-175">
                <label htmlFor="bsb" className="block text-sm font-medium text-gray-700" data-id="element-176">
                  BSB
                </label>
                <div className="mt-1" data-id="element-177">
                  <input type="text" name="bsb" id="bsb" value={newAccount.bsb} onChange={e => setNewAccount({
                ...newAccount,
                bsb: e.target.value
              })} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="e.g. 123-456" data-id="element-178" />
                </div>
              </div>
              <div className="sm:col-span-3" data-id="element-179">
                <label htmlFor="account-number" className="block text-sm font-medium text-gray-700" data-id="element-180">
                  Account Number
                </label>
                <div className="mt-1" data-id="element-181">
                  <input type="text" name="account-number" id="account-number" value={newAccount.accountNumber} onChange={e => setNewAccount({
                ...newAccount,
                accountNumber: e.target.value
              })} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="e.g. 12345678" data-id="element-182" />
                </div>
              </div>
            </div>
            <div className="mt-5 flex justify-end space-x-3" data-id="element-183">
              <button type="button" onClick={() => {
            setShowAddForm(false);
            setNewAccount({
              name: '',
              accountName: '',
              bsb: '',
              accountNumber: ''
            });
          }} className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-184">
                Cancel
              </button>
              <button type="button" onClick={handleAddAccount} disabled={!newAccount.name || !newAccount.accountName || !newAccount.bsb || !newAccount.accountNumber} className={`inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white ${!newAccount.name || !newAccount.accountName || !newAccount.bsb || !newAccount.accountNumber ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'}`} data-id="element-185">
                Add Account
              </button>
            </div>
          </div>
        </div>}
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-186">
        <ul className="divide-y divide-gray-200" data-id="element-187">
          {bankAccounts.map(account => <li key={account.id} className="px-4 py-4 sm:px-6" data-id="element-188">
              <div className="flex items-center justify-between" data-id="element-189">
                <div className="flex items-center" data-id="element-190">
                  <div className={`flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center ${account.isDefault ? 'bg-blue-100' : 'bg-gray-100'}`} data-id="element-191">
                    <span className={`text-lg font-medium ${account.isDefault ? 'text-blue-700' : 'text-gray-700'}`} data-id="element-192">
                      {account.name.charAt(0)}
                    </span>
                    {!account.isVerified && <span className="absolute top-0 right-0 block h-3 w-3 rounded-full bg-red-400 ring-2 ring-white transform translate-x-1/4 -translate-y-1/4" data-id="element-193"></span>}
                  </div>
                  <div className="ml-4" data-id="element-194">
                    <div className="flex items-center" data-id="element-195">
                      <h3 className="text-sm font-medium text-gray-900" data-id="element-196">
                        {account.name}
                      </h3>
                      {account.isDefault && <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800" data-id="element-197">
                          Default
                        </span>}
                      {account.isVerified ? <span className="ml-2 flex items-center text-sm text-green-600" data-id="element-198">
                          <CheckCircleIcon className="flex-shrink-0 mr-1 h-4 w-4 text-green-500" data-id="element-199" />
                          Verified
                        </span> : <span className="ml-2 flex items-center text-sm text-yellow-600" data-id="element-200">
                          <AlertCircleIcon className="flex-shrink-0 mr-1 h-4 w-4 text-yellow-500" data-id="element-201" />
                          Unverified
                        </span>}
                    </div>
                    <div className="mt-1 text-sm text-gray-500" data-id="element-202">
                      {account.isVerified ? <p data-id="element-203">
                          {account.accountName} • {account.bsb} •{' '}
                          {account.accountNumber}
                        </p> : <div className="flex items-center text-yellow-600" data-id="element-204">
                          <LockIcon className="h-4 w-4 mr-1" data-id="element-205" />
                          <p data-id="element-206">
                            Bank details hidden - verification required for
                            security
                          </p>
                        </div>}
                    </div>
                  </div>
                </div>
                <div className="flex space-x-2" data-id="element-207">
                  {!account.isVerified && <Link to={`/verify-bank-account/${account.id}`} className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-208">
                      Verify
                    </Link>}
                  {!account.isDefault && account.isVerified && <button type="button" onClick={() => handleSetDefault(account.id)} className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-209">
                      Set Default
                    </button>}
                  <button type="button" className="inline-flex items-center px-2 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-210">
                    <PencilIcon className="h-3.5 w-3.5" data-id="element-211" />
                  </button>
                  {!account.isDefault && <button type="button" onClick={() => handleDelete(account.id)} className="inline-flex items-center px-2 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-212">
                      <TrashIcon className="h-3.5 w-3.5 text-red-500" data-id="element-213" />
                    </button>}
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </div>;
};
export default ManageBankAccounts;